<template>
  <div id="products" tag="section">
    <v-row dense style="background-color: #fff">
      <v-col class="col-xs-2" style="text-align: right;">
        <span class="product-list-count">{{ productListCount }}</span>
        <!--          <v-btn-->
        <!--            icon-->
        <!--            class="float-right"-->
        <!--            color="secondary"-->
        <!--            @click="showProductCard()"-->
        <!--          >-->
        <!--            <v-icon>apps</v-icon>-->
        <!--          </v-btn>-->

        <v-btn
          icon
          class="float-right"
          color="secondary"
          @click="(showList = true), (showCard = false)"
        >
          <v-icon>view_headline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-card class="mx-auto product-list fade-enter-active" width="100%">
        <v-list two-line>
          <template v-for="(product, index) in productList">
            <v-hover :key="product.title" v-slot:default="{ hover }">
              <v-list-item
                :class="{
                        'elevation-12': hover,
                        locked: !parseInt(product.field_is_public) && !isLogin
                      }"
              >

                <v-list-item-avatar
                  @click="goProductDetail(product.uuid,!!parseInt(product.field_is_public))"
                >
                  <icon
                    width="50"
                    height="50"
                    :icon-name="product.parentTid"
                    :bg-color-class="product.field_product_brand"
                  >
                  </icon>
                </v-list-item-avatar>

                <v-list-item-content
                  @click="
                          goProductDetail(
                            product.uuid,
                            !!parseInt(product.field_is_public)
                          )
                        "
                >
                  <v-list-item-title>
                    <span>{{ product.title }}</span>
                    <span v-html="product.body"></span>
                  </v-list-item-title>
                </v-list-item-content>

                <template
                  v-if="!!parseInt(product.field_is_public) || isLogin"
                >
                  <v-list-item-action>
                    <v-btn
                      icon
                      @click="previewProduct(product)"
                    >
                      <v-icon class="material-icons-outlined">pageview</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      icon
                      @click="favoritesProductStar('product',product.isFeature ? 'delete' : 'add', product.uuid)"
                    >
                      <v-icon
                        v-if="!product.isFeature"
                        color="grey lighten-1"
                      >
                        star_border
                      </v-icon>
                      <v-icon v-else color="yellow">
                        star
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </template>

                <template v-else>
                  <v-list-item-action>
                    <v-btn icon>
                      <v-icon class="material-icons-outlined">lock</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-hover>
            <v-divider
              v-if="index + 1 < productList.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
        <infinite-loading
          :identifier="infiniteId"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
          :distance="distance"
        >
          <span slot="no-more">{{ $t('global.noMoreProduct') }}</span>
          <span slot="no-results">{{ $t('global.noMoreProduct') }}</span>
        </infinite-loading>
      </v-card>
    </v-row>

    <v-dialog
      v-model="requestProductDialog"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="344px"
    >
      <v-card>
        <product-details
          @fatherMethod="closeRequestDialog()"
          :product="selectedProduct"
          :preview-product-basic="previewProductBasicInformation"
          :preview-product-prop="previewProductProperties"
        >
        </product-details>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import config from "../../config";
  import $ from "jquery";
  import Icon from "../../components/svg/features/Icon";
  import {globalUtils} from "../../utils/globalUtils";
  import {mapState} from "vuex";
  import ProductDetails from "../ProductDetails";
  const isDev = process.env.NODE_ENV !== "production";
  // 每页显示的产品条数
  const pageCount = isDev ? config.dev.pageCount : config.prod.pageCount;

  export default {
    name: 'product-list',

    components: { Icon, ProductDetails },

    computed: {
      ...mapState({
        requestProductDialog: state => state.core.requestProductDialog,
        previewProductBasicInformation: state => state.product.productBasicInformation,
        previewProductProperties: state => state.product.productProperties,
        isLogin: state => state.user.isLogin,
        productListCount: state => state.product.productListCount,
        taxonomyProductApplication: state => state.core.taxonomyProductApplication,
        taxonomyProductType: state => state.core.taxonomyProductType,
        taxonomyProductBrand: state => state.core.taxonomyProductBrand
      })
    },

    data() {
      return {
        distance: -Infinity,
        infiniteId: +new Date(),
        productList: [],
        currentTerms: [],
        productsFilter: {
          'product_application_ids': 'all',
          'product_type_ids': 'all',
          'product_brand_ids': 'all',
        },
        subIds: [],
        selectedProduct: {},
      }
    },

    watch: {
      $route(to, from) {
        this.changeFilter();
        this.buildProductsFilter();
      },
    },

    mounted() {
      this.distance = 1;
      this.buildProductsFilter();
      this.changeFilter();
    },

    methods: {
      changeFilter() {
        this.productList = [];
        this.infiniteId += 1;
      },
      buildProductsFilter () {
        let vm = this
        vm.productQuery = vm.$router.history.current.query
        vm.currentTerms = []
        vm.subIds = []
        vm.productsFilter = {
          'product_application_ids': 'all',
          'product_type_ids': 'all',
          'product_brand_ids': 'all',
        }

        if (vm.productQuery.hasOwnProperty("industry")) {
          vm.getChildrenIds(vm.taxonomyProductApplication, vm.productQuery.industry)
          if (!vm.subIds) {
            vm.subIds = [];
          }
          vm.productsFilter.product_application_ids = vm.productQuery.industry + '+' + vm.subIds.join('+')
        }

        if (vm.productQuery.hasOwnProperty("product_type")) {
          // 获得当前层级产品类型的所有子类型
          vm.getChildrenIds(vm.taxonomyProductType, vm.productQuery.product_type)
          if (!vm.subIds) {
            vm.subIds = [];
          }
          vm.productsFilter.product_type_ids = vm.productQuery.product_type + '+' + vm.subIds.join('+')
        }

        if (vm.productQuery.hasOwnProperty("product_brand")) {
          vm.getChildrenIds(vm.taxonomyProductBrand, vm.productQuery.product_brand);
          if (!vm.subIds) {
            vm.subIds = [];
          }

          vm.productsFilter.product_brand_ids = vm.productQuery.product_brand + '+' + vm.subIds.join('+')
        }
      },

      getChildrenIds(terms, target_id, isTarget = false) {
        let vm = this
        if (!terms) {
          // return; 中断执行
          return;
        }
        for (let id in terms) {
          /**
           * 如果相等则返回所有的children ids
           * 如果不等则继续迭代每一个children
           */
          const childTerms = terms[id]['children']
          if (terms[id]['tid'] == target_id) {
            // 已经选中的分类获得他所有的孩子的id
            vm.subIds.push.apply(vm.subIds, terms[id]['children_ids'])
            vm.getChildrenIds(childTerms, target_id, true)

            // 设置当前顶部的过滤选项
            vm.setCurrentTerms(terms[id])
          }
          else {
            vm.getChildrenIds(childTerms, target_id)
          }

          // 所有选中的目标分类的所有子分类
          if (isTarget) {
            vm.getChildrenIds(childTerms, target_id, true)
            vm.subIds.push.apply(vm.subIds, terms[id]['children_ids'])
          }
        }
      },

      //递归设置当前过滤项及其所有父亲层级
      setCurrentTerms(targetTerm) {
        if (!targetTerm) {
          // return; 中断执行
          return;
        }
        let vm = this
        vm.currentTerms.unshift(targetTerm)
        let parentProductType = globalUtils.findParentTid(vm.taxonomyProductType, targetTerm['tid'])

        if (parentProductType && parentProductType['tid'] !== targetTerm['tid']) {
          // 如果当前存在父亲层级，那么继续向上追索
          vm.setCurrentTerms(parentProductType)
        }
      },

      goProductDetail(productId, UnLocked) {
        let vm = this;
        if (UnLocked) {
          // window.location.href = `/product/?product=${productId}`
          vm.$router.push({ path: '/product', query:{product: productId} });
        } else {
          if (!vm.isLogin) {
            vm.$store.commit("open_login_dialog");
          } else {
            // window.location.href = `/product/?product=${productId}`
            vm.$router.push({ path: '/product', query:{product: productId} });
          }
        }
      },

      previewProduct(product) {
        let vm = this;
        vm.$loading.show();

        // console.log(product, 'product in the preview product')
        vm.$store
          .dispatch("getProductDetails", {
            id: product.uuid
          })
          .then(() => {
            vm.selectedProduct = product;
            vm.$loading.hide();
            vm.$store.state.core.requestProductDialog = true;

            // console.log(product.uuid, '触发状态')
          });
      },

      closeRequestDialog() {
        this.$store.state.core.requestProductDialog = false;
      },

      favoritesProductStar(type, action, productId) {
        let vm = this;
        let favoriteInfo = {};
        if (!vm.isLogin) {
          vm.$store.commit("open_login_dialog");
        } else {
          favoriteInfo.type = type;
          favoriteInfo.action = action;
          favoriteInfo.id = productId;
          vm.$loading.show();
          vm.$store
            .dispatch("processFavoriteForUser", favoriteInfo)
            .then(result => {
              if (result.status === 200) {
                vm.productList = vm.productList.map(product => {
                  if (product.uuid === productId) {
                    if (action === "add") {
                      product.isFeature = true;
                    } else if (action === "delete") {
                      product.isFeature = false;
                    }
                  }
                  return product;
                });
              }

              vm.$loading.hide();
            });
        }
      },

      infiniteHandler($state) {
        let vm = this;
        let options = {};
        options.items_per_page = pageCount
        options.page = Math.ceil(vm.productList.length / pageCount)

        vm.$loading.show()
        vm.$store.dispatch("getProductList", {filter: vm.productsFilter, options: options}).then(() => {
          let products = vm.$store.state.product.productList;

          if (products.length) {
            vm.productList = vm.productList.concat(products);

            $state.loaded();
            vm.$loading.hide()
            if (products.length < pageCount) {
              $state.complete();
              vm.$loading.hide()
            }
          } else {
            $state.complete();
            vm.$loading.hide()
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .product-list-count {
    border: 1px solid #2196f3;
    border-radius: 8px;
    margin-right: 10px;
    padding: 2px 10px;
    line-height: 38px;
    color: #2196f3;
  }

  .product-list {
    .v-list {
      padding: 0;
      border-bottom: 1px solid #ddd;

      & > .v-list-item {
        &.locked {
          background-color: rgba(226, 213, 213, 0.32);
          color: #655c5c !important;

          a {
            color: #655c5c;
          }
        }

        .v-list-item__content {
          cursor: pointer;
        }
      }

      .v-avatar {
        cursor: pointer;

        i {
          height: 40px;
          width: 40px;
          margin-top: 0;
        }
      }

      .v-list-item__title {
        span {
          &:first-child {
            width: 40%;
            display: inline-block;
          }
        }
      }
    }
  }

  .infinite-loading-container {
    height: 72px;
    line-height: 72px;
  }

  @media screen and (max-width: 480px) {
    .product-list {
      .v-list {

        .v-list-item__title {
          display: flex;
          flex-direction: column;

          span {
            &:first-child {
              width: 40%;
              display: inline-block;
            }

            &:last-child {
              display: inline-block;

              ::v-deep p {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
</style>
